import React from 'react';
import { DueDate } from '../TaskCard.styles';
import { dayHeadingLabel } from '../../../utils/dayLabel';

/** The heading over a day's tasks: "Thursday · Oct 22", the day strong and its date soft (utils/dayLabel). */
const DayHeading = ({ day }: { day: string }) => {
  const { strong, soft } = dayHeadingLabel(day);
  return (
    <DueDate>
      <span>{strong}</span>
      {` · ${soft}`}
    </DueDate>
  );
};

export default DayHeading;
